import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantWording, DEFAULT_TENANT_WORDING } from './tenant-theme.interface';

@Injectable({ providedIn: 'root' })
export class TenantWordingService {
  private wordingSubject = new BehaviorSubject<TenantWording>(DEFAULT_TENANT_WORDING);
  wording$: Observable<TenantWording> = this.wordingSubject.asObservable();

  apply(wording: Partial<TenantWording>): void {
    // Filtramos undefined para que un caller no borre valores ya aplicados
    // (ej. un partial que solo trae appName no debería pisar otros campos).
    const overrides: Record<string, string> = {};
    for (const [key, value] of Object.entries(wording)) {
      if (typeof value === 'string') overrides[key] = value;
    }
    const merged: TenantWording = { ...this.wordingSubject.value, ...overrides };
    merged.appNameLower = merged.appName.toLowerCase();
    this.wordingSubject.next(merged);
  }

  get(key: string): string {
    return this.wordingSubject.value[key] ?? '';
  }

  getSnapshot(): Readonly<TenantWording> {
    return this.wordingSubject.value;
  }

  reset(): void {
    this.wordingSubject.next(DEFAULT_TENANT_WORDING);
  }
}
